module.exports = __webpack_public_path__ + "static/media/ser_iso_loc_out.6e26a1b8.png";